module.exports = __webpack_public_path__ + "img/boot-logo.7cf0f7c7.png";